import React from 'react';
import styled, { css } from 'styled-components';
import { mediaQuery } from 'components';
import { AULink } from 'components/AULink';
import LogoutButton from 'components/LogoutButton';
import Itly from 'itly';
import { useSelector } from 'react-redux';
import { paginationStateSelector } from 'store/ui/selectors';

const SideMenuList = styled.ul`
  display: flex;
  flex-flow: column nowrap;
  padding: 0;
  margin: 0;
`;

const SideMenuListItem = styled.li`
  display: flex;
  flex-flow: column nowrap;
  padding: 0;
  margin: 0 0 25px;
`;

const SectionTitle = styled.span`
  font-size: 11px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 1.6rem;
`;

const SideMenuListItemLinkStyle = css`
  font-weight: 400;
  font-size: 0.75rem;
  letter-spacing: 0;
  transition: 0.2s ease color;
  width: max-content;

  ${mediaQuery.large`
      font-size: .760rem;
    `}
    :hover {
    color: #959595;
  }
`;

const SideMenuListItemLink = styled(AULink)`
  ${SideMenuListItemLinkStyle}
`;

const SideMenuLogoutButton = styled(LogoutButton)`
  ${SideMenuListItemLinkStyle}
  text-transform: uppercase;
`;

interface SideMenuChild {
  name: string;
  path: string;
  isGatsbyPage?: boolean;
}

export interface SideMenuTitle {
  name: string;
  children: SideMenuChild[];
}

interface SideMenuProps {
  className?: string;
  sideMenu: SideMenuTitle[];
  addLogout: boolean;
  displaySectionTitles: boolean;
}

const SideMenu = ({ sideMenu, className, addLogout, displaySectionTitles }: SideMenuProps): React.JSX.Element => {
  const { currentPage } = useSelector(paginationStateSelector);
  const oneIndexedCurrentPage = currentPage + 1;

  return (
    <SideMenuList className={className}>
      <>
        {sideMenu.map(({ name, children }) => {
          return (
            <SideMenuListItem id={`side-menu-list-item-${name}`} key={`side-menu-list-item-${name}`}>
              {displaySectionTitles ? <SectionTitle>{name}</SectionTitle> : null}
              <SideMenuList
                className={className}
                key={`side-menu-list-child-item${name}`}
                id={`side-menu-list-child-item${name}`}
              >
                {children &&
                  children.map(({ name, path, ...optional }) => {
                    const linkToGatsby = optional.isGatsbyPage;
                    return (
                      <SideMenuListItem key={`side-menu-item-${name}`} id={`side-menu-item-${name}`}>
                        <SideMenuListItemLink
                          id={`side-menu-item-link${name}`}
                          key={`side-menu-item-link${name}`}
                          path={path}
                          linkToGatsby={linkToGatsby}
                          onClick={_e =>
                            Itly.clpLinkClicked({
                              link_type: 'text',
                              page_number: oneIndexedCurrentPage,
                              product_name: name
                            })
                          }
                        >
                          {name}
                        </SideMenuListItemLink>
                      </SideMenuListItem>
                    );
                  })}
                {addLogout ? <SideMenuLogoutButton id="side-menu-item-link-Logout" /> : null}
              </SideMenuList>
            </SideMenuListItem>
          );
        })}
      </>
    </SideMenuList>
  );
};

export default SideMenu;
